import { Box } from '@iheartjane/reefer';
import { useMemo } from 'react';
import type { ReactNode } from 'react';

import { CarouselCardContext } from './carouselCardContext';

import styles from './carouselCard.module.css';

type ScrollSnapAlignType = 'none' | 'start' | 'end' | 'center';

interface CarouselCardProps {
  /** Accessible label for the card (e.g. "1 of 10") */
  ariaLabel?: string;

  /** Carousel children, add carousel cards here */
  children: ReactNode;

  /** Set `scroll-snap-align` css property of card */
  scrollSnapAlign?: ScrollSnapAlignType;

  /** Width of the card on desktop / tablet  */
  width?: number | string;

  /** Width of the card on mobile */
  widthMobile?: number | string;
}

export function CarouselCard({
  ariaLabel,
  children,
  scrollSnapAlign = 'start',
  widthMobile,
  width,
}: CarouselCardProps) {
  const contextValue = useMemo(
    () => (ariaLabel ? { label: ariaLabel } : null),
    [ariaLabel]
  );

  return (
    <CarouselCardContext.Provider value={contextValue}>
      <Box
        ariaLabel={ariaLabel}
        className={styles['card']}
        height="100%"
        role={ariaLabel ? 'group' : undefined}
        style={{
          // expose values via custom properties for the CSS Module to consume
          '--carousel-card-scroll-snap-align': scrollSnapAlign,
          '--carousel-card-width-mobile':
            typeof widthMobile === 'number' ? `${widthMobile}px` : widthMobile,
          '--carousel-card-width':
            typeof width === 'number' ? `${width}px` : width,
        }}
      >
        {children}
      </Box>
    </CarouselCardContext.Provider>
  );
}
